/** Only permit http(s) links in storefront UI (blocks javascript: etc.). */
export function isSafeHttpUrl(url) {
    if (!url || typeof url !== "string") return false;
    try {
        const u = new URL(url.trim());
        return u.protocol === "http:" || u.protocol === "https:";
    } catch {
        return false;
    }
}

export function safeSocialHref(url, fallback = "#") {
    return isSafeHttpUrl(url) ? url.trim() : fallback;
}
